import React, { useState, useEffect } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { colors } from './Theme/WebTheme';

export default function CookieConsent({ storageKey = 'cookie_consent_v1' }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (!stored) setOpen(true);
    } catch (e) {
      setOpen(true);
    }
  }, [storageKey]);

  const accept = () => {
    try {
      window.localStorage.setItem(storageKey, 'accepted');
    } catch (e) {}
    setOpen(false);
  };

  const decline = () => {
    try {
      window.localStorage.setItem(storageKey, 'declined');
    } catch (e) {}
    setOpen(false);
  };

  if (!open) return null;

  // Forced translations for English and French
  const translations = {
    en: {
      text: 'We use cookies to improve your experience. By continuing you accept our use of cookies. See our privacy policy.',
      accept: 'Accept',
      decline: 'Decline'
    },
    fr: {
      text: "Nous utilisons des cookies pour améliorer votre expérience. En poursuivant, vous acceptez notre utilisation des cookies. Voir notre politique de confidentialité.",
      accept: 'Accepter',
      decline: 'Refuser'
    }
  };
  const lang = (typeof navigator !== 'undefined' && navigator.language && navigator.language.startsWith('fr')) ? 'fr' : 'en';

return (
    <Box
        component="div"
        role="dialog"
        aria-live="polite"
        sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 16,
            display: 'flex',
            justifyContent: 'center',
            zIndex: 1400,
            pointerEvents: 'none'
        }}
    >
        <Box
            sx={{
                maxWidth: 980,
                width: 'calc(100% - 32px)',
                backgroundColor: colors.WHITE,
                color: colors.BLACK,
                p: '12px 16px',
                borderRadius: 1,
                boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                pointerEvents: 'auto'
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography variant="body2">
                    {translations[lang].text}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={decline}
                    sx={{
                        color: colors.BLACK,
                        borderColor: colors.BLACK,
                        '&:hover': { borderColor: colors.BLACK }
                    }}
                >
                    {translations[lang].decline}
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    onClick={accept}
                    sx={{
                        backgroundColor: colors.Button_Primary,
                        color: colors.BLACK,
                        '&:hover': { backgroundColor: colors.Button_Secondary }
                    }}
                >
                    {translations[lang].accept}
                </Button>
            </Box>
        </Box>
    </Box>
);
}